var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoProfile = function SvgIcoProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 36 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A089E5",
    d: "M18 36.5c9.941 0 18-8.059 18-18S27.941.5 18 .5 0 8.559 0 18.5s8.059 18 18 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.41 13.531a6.458 6.458 0 1 1-12.818 1.579A6.458 6.458 0 0 1 24.41 13.53m-9.71 8.651h6.6c4.814 0 8.825 3.764 9.715 8.75A17.94 17.94 0 0 1 17.999 36.5h-.001q-.232 0-.465-.005a17.95 17.95 0 0 1-12.548-5.561c.89-4.987 4.9-8.75 9.715-8.75",
    clipRule: "evenodd"
  })));
};
export default SvgIcoProfile;